// Mock analytics data for Black Men's Wellness Retreat website
// Target URL: https://blackmens-wellness.emergent.host/

export const websiteInfo = {
  name: "The Reset: Black Men's Wellness Retreat",
  url: "https://blackmens-wellness.emergent.host/",
  eventDate: "July 23-26, 2026",
  location: "Panama City, Panama"
};

// Generate dates for the last 30 days
const generateDates = (days) => {
  const dates = [];
  const today = new Date();
  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    dates.push(date.toISOString().split('T')[0]);
  }
  return dates;
};

// Traffic data for charts
export const trafficData = {
  daily: generateDates(30).map((date, index) => {
    const baseVisits = 150 + Math.sin(index * 0.3) * 50;
    const variation = Math.random() * 40 - 20;
    const visitors = Math.floor(baseVisits + variation);
    const pageViews = Math.floor(visitors * (2.5 + Math.random() * 0.8));
    return {
      date,
      visitors,
      pageViews,
      registrations: Math.floor(visitors * (0.02 + Math.random() * 0.015))
    };
  }),
  weekly: [
    { week: 'Week 1', visitors: 1245, pageViews: 3102, registrations: 28 },
    { week: 'Week 2', visitors: 1389, pageViews: 3421, registrations: 34 },
    { week: 'Week 3', visitors: 1567, pageViews: 3890, registrations: 41 },
    { week: 'Week 4', visitors: 1723, pageViews: 4298, registrations: 52 }
  ]
};

// Summary stats
export const summaryStats = {
  totalVisitors: 5924,
  totalPageViews: 14711,
  uniqueVisitors: 4231,
  totalRegistrations: 155,
  registrationValue: 232500, // 155 * $1,500
  avgTimeOnSite: '4:32',
  bounceRate: 32.4,
  conversionRate: 3.67,
  realTimeUsers: 23,
  trends: {
    visitors: { value: 12.4, isPositive: true },
    pageViews: { value: 8.7, isPositive: true },
    registrations: { value: 24.2, isPositive: true },
    bounceRate: { value: 5.1, isPositive: true } // lower is better
  }
};

// Traffic sources
export const trafficSources = [
  { source: 'Direct', visitors: 2134, percentage: 36.0, color: 'hsl(42, 48%, 56%)' },
  { source: 'Social Media', visitors: 1658, percentage: 28.0, color: 'hsl(140, 25%, 65%)' },
  { source: 'Search', visitors: 1185, percentage: 20.0, color: 'hsl(180, 15%, 50%)' },
  { source: 'Email', visitors: 593, percentage: 10.0, color: 'hsl(30, 30%, 45%)' },
  { source: 'Referral', visitors: 354, percentage: 6.0, color: 'hsl(0, 0%, 40%)' }
];

// Social media breakdown
export const socialBreakdown = [
  { platform: 'Instagram', visitors: 745, percentage: 44.9 },
  { platform: 'LinkedIn', visitors: 498, percentage: 30.0 },
  { platform: 'Facebook', visitors: 282, percentage: 17.0 },
  { platform: 'Twitter/X', visitors: 133, percentage: 8.1 }
];

// Geographic data (Top locations)
export const geoData = [
  { country: 'United States', visitors: 4145, percentage: 70.0 },
  { country: 'Canada', visitors: 593, percentage: 10.0 },
  { country: 'United Kingdom', visitors: 355, percentage: 6.0 },
  { country: 'Jamaica', visitors: 296, percentage: 5.0 },
  { country: 'Nigeria', visitors: 237, percentage: 4.0 },
  { country: 'Other', visitors: 298, percentage: 5.0 }
];

// US States breakdown
export const usStatesData = [
  { state: 'Georgia', visitors: 621, percentage: 15.0 },
  { state: 'Texas', visitors: 538, percentage: 13.0 },
  { state: 'California', visitors: 497, percentage: 12.0 },
  { state: 'New York', visitors: 456, percentage: 11.0 },
  { state: 'Florida', visitors: 414, percentage: 10.0 }
];

// Top pages
export const topPages = [
  { page: '/', title: 'Home / Landing', views: 5842, avgTime: '2:45', bounceRate: 28.3 },
  { page: '/#speakers', title: 'Meet Your Guides', views: 3214, avgTime: '3:12', bounceRate: 22.1 },
  { page: '/#schedule', title: '4-Day Journey', views: 2856, avgTime: '2:58', bounceRate: 25.7 },
  { page: '/#pricing', title: 'Investment / Pricing', views: 1892, avgTime: '4:21', bounceRate: 18.4 },
  { page: '/#venue', title: 'Your Sanctuary', views: 1423, avgTime: '2:34', bounceRate: 31.2 },
  { page: '/#brotherhood', title: 'What Is Brotherhood?', views: 984, avgTime: '3:45', bounceRate: 20.8 }
];

// Registration funnel
export const registrationFunnel = [
  { step: 'Page Visit', count: 5924, percentage: 100 },
  { step: 'Scroll to Pricing', count: 2134, percentage: 36.0 },
  { step: 'Click Register', count: 642, percentage: 10.8 },
  { step: 'Start Checkout', count: 312, percentage: 5.3 },
  { step: 'Complete Registration', count: 155, percentage: 2.6 }
];

// Device breakdown
export const deviceData = [
  { device: 'Mobile', visitors: 3436, percentage: 58.0 },
  { device: 'Desktop', visitors: 2074, percentage: 35.0 },
  { device: 'Tablet', visitors: 414, percentage: 7.0 }
];

// Hourly traffic pattern (for today)
export const hourlyTraffic = Array.from({ length: 24 }, (_, hour) => {
  let baseTraffic;
  if (hour >= 9 && hour <= 12) baseTraffic = 15;
  else if (hour >= 12 && hour <= 14) baseTraffic = 12;
  else if (hour >= 17 && hour <= 22) baseTraffic = 20;
  else if (hour >= 0 && hour <= 6) baseTraffic = 3;
  else baseTraffic = 8;
  
  return {
    hour: `${hour.toString().padStart(2, '0')}:00`,
    visitors: Math.floor(baseTraffic + Math.random() * 5)
  };
});

// Recent activity (for live feed)
export const recentActivity = [
  { id: 1, type: 'visit', page: 'Home', location: 'Atlanta, GA', time: '2 min ago' },
  { id: 2, type: 'registration', page: 'Checkout', location: 'Houston, TX', time: '5 min ago' },
  { id: 3, type: 'visit', page: 'Meet Your Guides', location: 'Brooklyn, NY', time: '7 min ago' },
  { id: 4, type: 'click', page: 'Register Now', location: 'Chicago, IL', time: '8 min ago' },
  { id: 5, type: 'visit', page: '4-Day Journey', location: 'Los Angeles, CA', time: '12 min ago' },
  { id: 6, type: 'visit', page: 'Home', location: 'Toronto, CA', time: '15 min ago' },
  { id: 7, type: 'registration', page: 'Checkout', location: 'Miami, FL', time: '18 min ago' },
  { id: 8, type: 'visit', page: 'Investment', location: 'London, UK', time: '22 min ago' }
];
